import { Injectable } from '@angular/core';

@Injectable()
export class ApiUrlEnum {
    public static BackOffice = 0;
    public static Ticari = 1;
    public static Gib = 1;
    public static Smm = 2;
    public static Emm = 3;
    public static Ticket = 4;
    public static Bill = 5;
    public static ExpenseVoucher = 6;
}
